import { Skeleton } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { useAdminOrganizationsForSelect } from '@/features/admin/organizations/hooks/use-admin-organizations'
import { UserForm } from '@/features/admin/users/components/user-form'
import { useAdminUser } from '@/features/admin/users/hooks/use-admin-user'
import { useUpdateAdminUser } from '@/features/admin/users/hooks/use-update-admin-user'
import { router } from '@/router'

export const Route = createFileRoute('/admin/users/$userId/edit')({
  component: AdminUserEditPage,
})

function AdminUserEditPage() {
  const { t } = useTranslation('admin')
  const { userId } = Route.useParams()
  const id = Number(userId)
  const { data: user, isPending } = useAdminUser(id)
  const { data: organizations } = useAdminOrganizationsForSelect()
  const { mutate, isPending: isSubmitting } = useUpdateAdminUser(id)

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('users.edit.title')}
        subtitle={user ? `${user.firstName} ${user.lastName}` : undefined}
      />
      <div className="mx-auto max-w-3xl">
        {isPending || !user ? (
          <Skeleton className="h-112 w-full rounded-md" />
        ) : (
          <UserForm
            defaultValues={{
              email: user.email,
              firstName: user.firstName,
              lastName: user.lastName,
              phoneNumber: user.phoneNumber ?? '',
              platformRole: user.platformRole,
              status: user.status,
              organizationId: user.organization?.id,
              organizationRole: user.organizationRole ?? undefined,
            }}
            organizations={organizations ?? []}
            hidePassword
            isSubmitting={isSubmitting}
            onSubmit={(values) => {
              const { password: _password, ...rest } = values
              mutate(rest)
            }}
            onCancel={() => router.navigate({ to: '/admin/users' })}
            submitLabel={t('users.edit.submit')}
          />
        )}
      </div>
    </div>
  )
}
